import { getRequest, postRequest } from "./Api";
import { API_URL } from "./Constant";
export { getRequest, postRequest, API_URL };